import React from 'react';
import styled from 'styled-components';
import { BodyText } from './ui';
import { navigateToHash } from '../utils/hashRouter';

const AnnouncementBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2b388f;
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  height: 42px;

  @media (max-width: 768px) {
    padding: 6px 15px;
    font-size: 12px;
    min-height: 35px;
  }

  @media (max-width: 480px) {
    padding: 5px 10px;
    font-size: 11px;
    min-height: 30px;
  }
`;

const AnnouncementContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 120px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 30px;
  }

  @media (max-width: 480px) {
    gap: 20px;
  }
`;

const AnnouncementText = styled(BodyText)`
  color: white;
  margin: 0;
  line-height: 1.4;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const ClickableText = styled(AnnouncementText)`
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 20px;
  background: white;
  opacity: 0.7;

  @media (max-width: 768px) {
    height: 16px;
  }

  @media (max-width: 480px) {
    height: 14px;
  }
`;

const AnnouncementBar = ({
  leftText = 'Shop JoyCook Kitchen Essentials >',
  rightText = 'Nature Republic Aloe Vera Skincare >',
  show = true,
}) => {
  if (!show) return null;

  const handleLeftClick = () => {
    navigateToHash('/search', {
      category: 'kitchen-joy-cook',
      page: '1',
    });
  };

  const handleRightClick = () => {
    navigateToHash('/search', {
      category: 'health-beauty',
      page: '1',
      filter: '3656',
    });
  };

  return (
    <AnnouncementBarWrapper>
      <AnnouncementContent>
        <ClickableText onClick={handleLeftClick}>{leftText}</ClickableText>
        <Divider />
        <ClickableText onClick={handleRightClick}>{rightText}</ClickableText>
      </AnnouncementContent>
    </AnnouncementBarWrapper>
  );
};

export default AnnouncementBar;
